import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
// import CreatableSelect from "react-select/creatable";

import FeatherIcon from "feather-icons-react";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import { useFormik, FormikProvider, FieldArray } from "formik";
//import * as Yup from "yu78p";
import { Apitoken, Authtoken  } from '../Global';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import $ from "jquery";
const EmployeeAdd = () => {

  const [backendErrors, setBackendErrors] = useState([]);
  const [permission, setPermission] = useState({});
  const [statusOptions, setStatusOptions] = useState([]);
  const [menu, setMenu] = useState(false);
  // const [otheroption, setOtheroption] = useState(false);
  const currencySymbol  = 'dh';
  const [locationLoading, setLocationLoading] = useState([]);
  const [allowancetypes, setAllowancetypes] = useState([]);
  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  };
  const [defaultDate, setDefaultDate] = useState(formatDate(new Date()));
  const formik = useFormik({
    initialValues: {
      first_name: "",
      gender: "",
      shift: "",
      phone_number: "",
      profile_picture: "",
      last_name: "",
      date_of_birth: defaultDate,
      join_date:defaultDate,
      contract_end_date:defaultDate,
      employment_date:'',
      employee_status: "",
      location:"",
      currency:"4",
      salary_netto: "",
      salary_brutto: "",
      family_situation: "",
      cnss_status:'',
      rib: "",
      cin: "",
      cnss: "",
      matricule: "",
      address: "",
      position: "",
      payment_method: "",
      status:'',
      number_of_children: "",
      seniority: "",
      income_tax_deduction: '',
      transport_allowance: 0,
      meal_allowance: 0,
      documents:[],
      allowances: [],
    },
    onSubmit: (values,{ setSubmitting }) => {
      axios
        .post("/employees/add", values, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
        .then((response) => {
          
          $("#form-submit").text("Add Employee");
          delete backendErrors['error'];
          //actions.setSubmitting(false);
          setSubmitting(false);
          if (response.data.code == 200) {
            //setBackendSuccess(response.data.message);
            toast.success(response.data.message);
            
           // actions.resetForm();
            setTimeout(() => {
              window.location.href = "/employees";
            }, 1000);
          }  else if (response.data.code == 422) {
              setBackendErrors(response.data.error);
          }
          else if (response.data.code == 401) {
            setBackendErrors(response.data.error);
          }
          else {
             setBackendErrors(response.data.error);
          }
        })
        .catch((error) => {
          console.log(error)
          //actions.setSubmitting(false);
        });
    },
  });

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };
 

  useEffect(() => {
        setPermission(FindModuleById(251)); 
        console.log("permission");
        console.log(permission);
        axios.get("/helpers/employees-status", {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
        .then((response) => {
          if(response.data.code == 200){
            let emp_status = response.data.data.emp_status;
           // setPackagingTypesLists(materials_payment_status);
            let emp_statusList = emp_status.map((ord, index) => ({
              label:  ord.title ,
              value: ord.id,
              key: `sts-${index}`,
            }));
            setStatusOptions(emp_statusList);
        }else{
            console.log("API response is not an array");
          }
                  
        })
        .catch((error) => {
          console.log(error);
        });
        axios.get("/helper/employees-allowances-types", {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
        .then((response) => {
          if(response.data.code == 200){
            let emp_status = response.data.data.types;
           // setPackagingTypesLists(materials_payment_status);
            let emp_statusList = emp_status.map((ord, index) => ({
              label:  ord.title ,
              value: ord.id,
              key: `sts-${index}`,
            }));
            setAllowancetypes(emp_statusList);
        }else{
            console.log("API response is not an array");
          }
                  
        })
        .catch((error) => {
          console.log(error);
        });
        
        
      axios
      .get(`/helpers/loading-locations`, {
        headers: {
          Authorization: `Bearer ${Authtoken}`,
          Apitoken: Apitoken,
        },
      })
      .then((response) => {
        if (response.data.code == 200) {
          let locations = response.data.data.locations;
          let emp_statusList = locations.map((ord, index) => ({
            label:  ord.title ,
            value: ord.id,
            key: `sts-${index}`,
          }));
          

          setLocationLoading(emp_statusList);



        } else {
          console.log("API response is not an array");
        }
      })
      .catch((error) => {
        console.log(error);
      });

}, []);
const customHandleInput = (event) => {
  const Input_name = event.target.name;
  delete backendErrors[Input_name];
};


const familyStatus = [
  { value: 1, label: "MARIE (E)" },
  { value: 2, label: "CELIBATAIRE" },
  { value: 3, label: "Divorce(e)" },
  { value: 4, label: "Veuf/Veuve" },
];
const shiftlist = [
 
  { value: 1, label: "Shift 1" },
  { value: 2, label: "Shift 2" }
];

const paymentStatus =[
  { value: 'VIREMENT', label: "VIREMENT" },
  { value: 'ESPECE', label: "ESPECE" },
];

const empStatus = [
  { value: 'active', label: "Active" },
  { value: 'inactive', label: "Inactive" },
];
const seniorityStatus = [
  { value: '0', label: "0%" },
  { value: '5', label: "5%" },
  { value: '10', label: "10%" },
  { value: '15', label: "15%" },
  { value: '20', label: "20%" },
  { value: '25', label: "25%" },
];

const taxdeductionStatus = [
  { value: '0', label: "0" },
  { value: '250', label: "250" },
  { value: '666.67', label: "666.67" },
  { value: '1166.67', label: "1166.67" },
  { value: '1433.33', label: "1433.33" },
  { value: '2033.33', label: "2033.33" },
];
const cnsslist = [
  { value: '1', label: "Déclaré(e)" },
  { value: '0', label: "Non - Déclaré(e)" }
];

const cnsslistFunc = (event) =>{
  const val = event.value;
    $(".cnss_div").hide();
  
  if(val ==1){  
    $(".cnss_div").show();
  }
}

const customHandleStatus = (event) =>{
  const val = event.value;
  if(val ==2){  
    $(".salary_netto_div").hide();
    $(".salary_brutto_div").hide();
  }else{
    $(".salary_netto_div").show();
    $(".salary_brutto_div").show();
  }
  $(".contract_end_date_div").hide();

  if(val ==1){
    $(".contract_end_date_div").show();
  }  
  console.log(event);
}

// const selectotherType = (type) =>{
//   //const val = type.value;
//   console.log(type);
//   if(type.label == "Other"){
//     setOtheroption(true);
//   }else{
//       setOtheroption(false);
//   }
// }
const [otherOptions, setOtherOptions] = useState({}); // {0: true, 1: false, ...}

// function
const selectotherType = (selectedOption, index) => {
  setOtherOptions((prev) => ({
    ...prev,
    [index]: selectedOption?.label === "Other"
  }));
};


const handleSelectChange = (name, selectedOption) => {
  const value = selectedOption ? selectedOption.value : "";
  updateFormikValue(name, value);
  customHandleInput({ target: { name, value } });
};

const updateFormikValue = (name, value) => {
  formik.setFieldValue(name, value);
};
  const getFileData = async (event) =>{
    const file_link = event.target.files[0];
    const fileName = file_link.name;
    const withoutExtension = fileName.replace(/\.[^.]+$/, '');

    var id_value = event.target.id;
    const ids = id_value.split("-");
    formik.values.documents[ids[1]].file_name = withoutExtension;
  }  
  
  const genderlist = [
  { value: 'H', label: "H"},
  { value: 'F', label: "F" }
];


  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Employee</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/employees">Employees</Link>
                      <ToastContainer />


                    </li>
                    <li className="breadcrumb-item active">Add Employee</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                {permission && permission.add == 1 && (
                  <div className="card-body">
                    <h4 className="card-title">Employee Information</h4>
                    <FormikProvider value={formik}>
                    <form action="#" onSubmit={formik.handleSubmit}>
                    <div className="row justify-content-lg-center">
                       <div className="col-lg-10">
                          <div className="text-center py-5">
                            <label
                              className="avatar avatar-xxl profile-cover-avatar"
                              htmlFor="avatar_upload"
                            >
                              <img
                                className="avatar-img"
                                src={formik.values.profile_picture }
                                alt="Profile Image"
                              />
                              <input
                                type="file"
                                id="avatar_upload"
                                onChange={(event) => {
                                  console.log(event.target);
                                  const file = event.target.files[0];
                                  const reader = new FileReader();
                                  // console.log(reader);
                                  reader.onloadend = () => {
                                    formik.handleChange({
                                      target: {
                                        name: "profile_picture",
                                        value: reader.result,
                                      },
                                    });
                                  };

                                  if (file) {
                                    reader.readAsDataURL(file);
                                  }
                                }}
                              />
                              
                              <span className="avatar-edit">
                                <FeatherIcon
                                  icon="edit-2"
                                  className="avatar-uploader-icon shadow-soft"
                                />
                              </span>
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group">
                            <label> First Name</label>
                            <input
                              type="text"
                              name="first_name"
                              value={formik.values.first_name}
                              className={
                                backendErrors.first_name
                                  ? "form-input form-control input-error"
                                  : "form-input form-control"
                              }
                           
                              onChange={(e) => {
                                formik.handleChange(e);
                                customHandleInput(e);
                              }}
                               onBlur={formik.handleBlur}
                            />
                           <small>
                              {backendErrors.first_name && (
                                <span className="form-error mt-1">
                                  {backendErrors.first_name}
                                </span>
                              )}
                            </small>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label> Last Name</label>
                            <input
                              type="text"
                              name="last_name"
                              value={formik.values.last_name}
                              className={
                                backendErrors.last_name
                                  ? "form-input form-control input-error"
                                  : "form-input form-control"
                              }
                           
                              onChange={(e) => {
                                formik.handleChange(e);
                                customHandleInput(e);
                              }}
                               onBlur={formik.handleBlur}
                            />
                           <small>
                              {backendErrors.last_name && (
                                <span className="form-error mt-1">
                                  {backendErrors.last_name}
                                </span>
                              )}
                            </small>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group status">
                            <label>Gender</label>
                            <Select
                               className="w-100"
                               value={genderlist.find(option => option.value == formik.values.gender) || null} // Ensure correct format
                               name="gender"
                                onChange={(selectedOption) => handleSelectChange("gender", selectedOption)}
                               onBlur={formik.handleBlur}
                               options={genderlist}
                               placeholder="Select"

                            />

                            <small>
                              {backendErrors.gender  && (
                                <span className="form-error mt-1">
                                  {backendErrors.gender}
                                </span>
                              )}
                            </small>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label> Phone Number</label>
                            <input
                              type="text"
                              name="phone_number"
                              value={formik.values.phone_number}
                              className={
                                backendErrors.phone_number
                                  ? "form-input form-control input-error"
                                  : "form-input form-control"
                              }
                           
                              onChange={(e) => {
                                formik.handleChange(e);
                                customHandleInput(e);
                              }}
                               onBlur={formik.handleBlur}
                            />
                           <small>
                              {backendErrors.phone_number && (
                                <span className="form-error mt-1">
                                  {backendErrors.phone_number}
                                </span>
                              )}
                            </small>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label> Date Of Birth</label>
                            <input
                              type="date"
                              name="date_of_birth"
                              value={formik.values.date_of_birth}
                              className={
                                backendErrors.date_of_birth
                                  ? "form-input form-control input-error"
                                  : "form-input form-control"
                              }
                           
                              onChange={(e) => {
                                formik.handleChange(e);
                                customHandleInput(e);
                                setDefaultDate(e.target.value)
                              }}
                               onBlur={formik.handleBlur}
                            />
                           <small>
                              {backendErrors.date_of_birth && (
                                <span className="form-error mt-1">
                                  {backendErrors.date_of_birth}
                                </span>
                              )}
                            </small>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label> Join Date</label>
                            <input
                              type="date"
                              name="join_date"
                              value={formik.values.join_date}
                              className={
                                backendErrors.join_date
                                  ? "form-input form-control input-error"
                                  : "form-input form-control"
                              }
                           
                              onChange={(e) => {
                                formik.handleChange(e);
                                customHandleInput(e);
                                setDefaultDate(e.target.value)
                              }}
                               onBlur={formik.handleBlur}
                            />
                           <small>
                              {backendErrors.join_date && (
                                <span className="form-error mt-1">
                                  {backendErrors.join_date}
                                </span>
                              )}
                            </small>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label> Employment Date</label>
                            <input
                              type="date"
                              name="employment_date"
                              value={formik.values.employment_date}
                              className={
                                backendErrors.employment_date
                                  ? "form-input form-control input-error"
                                  : "form-input form-control"
                              }
                           
                              onChange={(e) => {
                                formik.handleChange(e);
                                customHandleInput(e);
                                setDefaultDate(e.target.value)
                              }}
                               onBlur={formik.handleBlur}
                            />
                           <small>
                              {backendErrors.employment_date && (
                                <span className="form-error mt-1">
                                  {backendErrors.employment_date}
                                </span>
                              )}
                            </small>
                          </div>
                        </div>
                        
                        <div className="col-md-6">
                          <div className="form-group status">
                            <label>Family Situation</label>
                            <Select
                               className="w-100"
                               value={familyStatus.find(option => option.value == formik.values.family_situation) || null} // Ensure correct format
                               name="family_situation"
                                onChange={(selectedOption) => handleSelectChange("family_situation", selectedOption)}
                               onBlur={formik.handleBlur}
                               options={familyStatus}
                               placeholder="Select"

                            />

                            <small>
                              {backendErrors.family_situation  && (
                                <span className="form-error mt-1">
                                  {backendErrors.family_situation}
                                </span>
                              )}
                            </small>
                          </div>
                        </div>
                       

                        <div className="col-md-6">
                            <div className="form-group employee_status">
                              <label>Select Employee Status </label>
                              <Select
                                className="w-100"
                                value={statusOptions.find(option => option.value == formik.values.employee_status) || null} // Ensure correct format
                                name="employee_status"
                                onChange={(selectedOption) => {
                                  handleSelectChange("employee_status", selectedOption);
                                  customHandleStatus(selectedOption);
                                  
                                }}
                                onBlur={formik.handleBlur}
                                options={statusOptions}
                                placeholder="Select"
                              />
                            <small>
                                {backendErrors.employee_status && (
                                  <span className="form-error mt-1">
                                    {backendErrors.employee_status}
                                  </span>
                                )}
                              </small>
                            </div>
                        </div>

                        <div className="col-md-6">
                        <div className="form-group">
                          <label>Location</label>
                            <Select

                                className="w-100"
                                value={locationLoading.find(option => option.value == formik.values.location) || null} // Ensure correct format
                                name="location"
                                  onChange={(selectedOption) => handleSelectChange("location", selectedOption)}
                                onBlur={formik.handleBlur}
                                options={locationLoading}
                                placeholder="Select"
                            />

                         
                            <small>
                              {backendErrors.location && (
                                  <span className="form-error mt-1">
                                    {backendErrors.location}
                                  </span>
                                )}
                            </small>
                          </div>
                        </div>
                         <div className="col-md-6">
                          <div className="form-group status">
                            <label>Shift</label>
                            <Select
                               className="w-100"
                               value={shiftlist.find(option => option.value == formik.values.shift) || null} // Ensure correct format
                               name="shift"
                                onChange={(selectedOption) => handleSelectChange("shift", selectedOption)}
                               onBlur={formik.handleBlur}
                               options={shiftlist}
                               placeholder="Select"

                            />

                            <small>
                              {backendErrors.family_situation  && (
                                <span className="form-error mt-1">
                                  {backendErrors.family_situation}
                                </span>
                              )}
                            </small>
                          </div>
                        </div>
                          <div className="col-md-6 contract_end_date_div" style={{display:'none'}} >
                          <div className="form-group">
                            <label> Contract End date</label>
                            <input
                              type="date"
                              name="contract_end_date"
                              value={formik.values.contract_end_date}
                              className={
                                backendErrors.contract_end_date
                                  ? "form-input form-control input-error"
                                  : "form-input form-control"
                              }
                           
                              onChange={(e) => {
                                formik.handleChange(e);
                                customHandleInput(e);
                                setDefaultDate(e.target.value)
                              }}
                               onBlur={formik.handleBlur}
                            />
                           <small>
                              {backendErrors.contract_end_date && (
                                <span className="form-error mt-1">
                                  {backendErrors.contract_end_date}
                                </span>
                              )}
                            </small>
                          </div>
                        </div>
                        <div className="col-md-6  salary_netto_div">
                          <div className="form-group">
                            <label>Salary Netto</label>
                           
                            <div className="input-group">
                                  <input 
                                   type="text"
                                   onKeyPress={(event) => {
                                     // Allow only numbers (0-9)
                                     if (!/^[0-9.]$/.test(event.key) || (event.key == '.' && event.target.value.includes('.'))) {
                                      event.preventDefault();
                                    }
                                   }}
                                  name="salary_netto"
                                  value={formik.values.salary_netto}
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    customHandleInput(e);
                                  }}
                                  onBlur={formik.handleBlur}
                                  className="form-control" placeholder="Salary Netto" aria-label="Salary Netto" aria-describedby="basic-addon2" />
                                  <div className="input-group-append">
                                      <span className="input-group-text" id="basic-addon2">{currencySymbol}</span>
                                  </div>
                              </div>
                            <small>
                              {backendErrors.salary_netto && (
                                <span className="form-error mt-1">
                                  {backendErrors.salary_netto}
                                </span>
                              )}
                            </small>
                          </div>
                        </div>
                        
                        <div className="col-md-6 salary_brutto_div">
                          <div className="form-group">
                            <label>Salary Brutto</label>
                           
                            <div className="input-group">
                                  <input  type="text"
                                    onKeyPress={(event) => {
                                      // Allow only numbers (0-9)
                                      if (!/^[0-9.]$/.test(event.key) || (event.key == '.' && event.target.value.includes('.'))) {
                                        event.preventDefault();
                                      }
                                    }}
                                  name="salary_brutto"
                                  value={formik.values.salary_brutto}
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    customHandleInput(e);
                                  }}
                                  onBlur={formik.handleBlur}
                                  className="form-control" placeholder="Salary Brutto" aria-label="Salary Brutto" aria-describedby="basic-addon2" />
                                  <div className="input-group-append">
                                      <span className="input-group-text" id="basic-addon2">{currencySymbol}</span>
                                  </div>
                              </div>
                            <small>
                              {backendErrors.salary_brutto && (
                                <span className="form-error mt-1">
                                  {backendErrors.salary_brutto}
                                </span>
                              )}
                            </small>
                          </div>
                        </div>
                        
                        
                           <div className="col-md-6">
                          <div className="form-group">
                            <label>RIB</label>
                           
                            <div className="input-group">
                                  <input type="text" 
                                  name="rib"
                                  value={formik.values.rib}
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    customHandleInput(e);
                                  }}
                                  onBlur={formik.handleBlur}
                                  className="form-control"
                                  placeholder="RIB"  />
                                  
                              </div>
                            <small>
                              {backendErrors.rib && (
                                <span className="form-error mt-1">
                                  {backendErrors.rib}
                                </span>
                              )}
                            </small>
                          </div>
                        </div>
                             
                        <div className="col-md-6">
                          <div className="form-group">
                            <label>CIN</label>
                           
                            <div className="input-group">
                                  <input type="text" 
                                  name="cin"
                                  value={formik.values.cin}
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    customHandleInput(e);
                                  }}
                                  onBlur={formik.handleBlur}
                                  className="form-control"
                                  placeholder="CIN"  />
                                  
                              </div>
                            <small>
                              {backendErrors.cin && (
                                <span className="form-error mt-1">
                                  {backendErrors.cin}
                                </span>
                              )}
                            </small>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group status">
                            <label>CNSS Satus</label>
                            <Select
                                className="w-100"
                                value={cnsslist.find(option => option.value == formik.values.cnss_status) || null} // Ensure correct format
                                name="cnss_status"
                                  
                                     onChange={(selectedOption) => {
                                  handleSelectChange("cnss_status", selectedOption);
                                  cnsslistFunc(selectedOption);
                                  
                                }}
                                onBlur={formik.handleBlur}
                                options={cnsslist}
                                placeholder="Select"
                              
                            />
                            <small>
                              {backendErrors.cnss_status  && (
                                <span className="form-error mt-1">
                                  {backendErrors.cnss_status}
                                </span>
                              )}
                            </small>
                          </div>
                        </div>
                              
                        <div className="col-md-6 cnss_div" style={{display:'none'}}>
                          <div className="form-group">
                            <label>CNSS Number</label>
                           
                            <div className="input-group">
                                  <input type="text" 
                                  name="cnss"
                                  value={formik.values.cnss}
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    customHandleInput(e);
                                  }}
                                  onBlur={formik.handleBlur}
                                  className="form-control"
                                  placeholder="CNSS Number"  />
                                 
                              </div>
                            <small>
                              {backendErrors.cnss && (
                                <span className="form-error mt-1">
                                  {backendErrors.cnss}
                                </span>
                              )}
                            </small>
                          </div>
                        </div>
                        
                             
                        <div className="col-md-6">
                          <div className="form-group">
                            <label>Matricule</label>
                           
                            <div className="input-group">
                                  <input type="text" 
                                  name="matricule"
                                  value={formik.values.matricule}
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    customHandleInput(e);
                                  }}
                                  onBlur={formik.handleBlur}
                                  placeholder="Matricule" 
                                   className="form-control"  />
                                 
                              </div>
                            <small>
                              {backendErrors.matricule && (
                                <span className="form-error mt-1">
                                  {backendErrors.matricule}
                                </span>
                              )}
                            </small>
                          </div>
                        </div>
                        
                              
                        <div className="col-md-6">
                          <div className="form-group">
                            <label>Position</label>
                           
                            <div className="input-group">
                                  <input type="text" 
                                  name="position"
                                  value={formik.values.position}
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    customHandleInput(e);
                                  }}
                                  onBlur={formik.handleBlur}
                                  placeholder="Enter Position" 
                                   className="form-control"  />
                                 
                              </div>
                            <small>
                              {backendErrors.position && (
                                <span className="form-error mt-1">
                                  {backendErrors.position}
                                </span>
                              )}
                            </small>
                          </div>
                        </div>
                                  
                        <div className="col-md-6">
                          <div className="form-group">
                            <label>Address</label>
                           
                            <div className="input-group">
                                  <input type="text" 
                                  name="address"
                                  value={formik.values.address}
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    customHandleInput(e);
                                  }}
                                  onBlur={formik.handleBlur}
                                  placeholder="Enter Address" 
                                   className="form-control"  />
                                 
                              </div>
                            <small>
                              {backendErrors.address && (
                                <span className="form-error mt-1">
                                  {backendErrors.address}
                                </span>
                              )}
                            </small>
                          </div>
                        </div>
           
                        <div className="col-md-6">
                          <div className="form-group">
                            <label>Number of children</label>
                            <div className="input-group">
                                  <input 
                                   type="text"
                                   onKeyPress={(event) => {
                                     // Allow only numbers (0-9)
                                     if (!/^[0-9]$/.test(event.key)) {
                                     event.preventDefault();
                                     }
                                   }}
                                  name="number_of_children"
                                  value={formik.values.number_of_children}
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    customHandleInput(e);
                                  }}
                                  onBlur={formik.handleBlur}
                                  placeholder="Number of children" 
                                   className="form-control"  />
                                 
                              </div>
                            <small>
                              {backendErrors.number_of_children && (
                                <span className="form-error mt-1">
                                  {backendErrors.number_of_children}
                                </span>
                              )}
                            </small>
                          </div>
                        </div>

                   
                       
                     
                        <div className="col-md-6">
                          <div className="form-group status">
                            <label>Payment Status</label>
                            <Select
                              className="w-100"
                              value={paymentStatus.find(option => option.value == formik.values.payment_method) || null} // Ensure correct format
                              name="payment_method"
                                onChange={(selectedOption) => handleSelectChange("payment_method", selectedOption)}
                              onBlur={formik.handleBlur}
                              options={paymentStatus}
                              placeholder="Select"
                            />
                            <small>
                              {backendErrors.payment_method  && (
                                <span className="form-error mt-1">
                                  {backendErrors.payment_method}
                                </span>
                              )}
                            </small>
                          </div>
                        </div>

                        

                        <div className="col-md-6">
                          <div className="form-group status">
                            <label>Seniority</label>
                            <Select
                                className="w-100"
                                value={seniorityStatus.find(option => option.value == formik.values.seniority) || null} // Ensure correct format
                                name="seniority"
                                  onChange={(selectedOption) => handleSelectChange("seniority", selectedOption)}
                                onBlur={formik.handleBlur}
                                options={seniorityStatus}
                                placeholder="Select"
                            />
                            <small>
                              {backendErrors.seniority  && (
                                <span className="form-error mt-1">
                                  {backendErrors.seniority}
                                </span>
                              )}
                            </small>
                          </div>
                        </div>
                        
                        <div className="col-md-6">
                          <div className="form-group status">
                            <label>Imcome tax Deducation</label>
                            <Select
                                className="w-100"
                                value={taxdeductionStatus.find(option => option.value == formik.values.income_tax_deduction) || null} // Ensure correct format
                                name="income_tax_deduction"
                                  onChange={(selectedOption) => handleSelectChange("income_tax_deduction", selectedOption)}
                                onBlur={formik.handleBlur}
                                options={taxdeductionStatus}
                                placeholder="Select"
                              
                            />
                            <small>
                              {backendErrors.income_tax_deduction  && (
                                <span className="form-error mt-1">
                                  {backendErrors.income_tax_deduction}
                                </span>
                              )}
                            </small>
                          </div>
                        </div>


                        <div className="col-md-6">
                          <div className="form-group status">
                            <label> Status</label>
                            <Select
                              className="w-100"
                              value={empStatus.find(option => option.value == formik.values.status) || null} // Ensure correct format
                              name="status"
                                onChange={(selectedOption) => handleSelectChange("status", selectedOption)}
                              onBlur={formik.handleBlur}
                              options={empStatus}
                              placeholder="Select"
                            />
                            <small>
                              {backendErrors.status  && (
                                <span className="form-error mt-1">
                                  {backendErrors.status}
                                </span>
                              )}
                            </small>
                          </div>
                        </div>



                      </div>

                     <div className="row">
                          <div className="col-md-6">
                            <h4 className="card-title">
                              <br />
                              Add  Documents
                            </h4>
                          </div>
                        </div>
                        <FieldArray
                          name="documents"
                          render={(arrayHelpers) => (
                            <div>
                              <button
                                className="btn btn-primary mb-3"
                                type="button"
                                // onClick={handleShow}
                                onClick={() =>
                                  arrayHelpers.push({
                                    file_link: "",
                                    file_name: "",
                                                                  
                                  })
                                }
                              >
                                +
                              </button>
                              <table className="table">
                                <tbody>
                                  {formik.values.documents.map((friend, index) => (
                                    <tr key={index}>
                                                                            <td>
                                        <div className="form-group status pt-3" >
                                          <label>Upload File</label><br/>
                                          <input
                                          className="form-group"
                                          type="file"
                                          name={`documents[${index}].file_link`}
                                          id={`fileupload-${index}`}

                                          onChange={(event) => {
                                            getFileData(event);

                                            const file_link = event.target.files[0];
                                            //console.log("file:", file_link);
                                            //const fileName = file_link.name;
                                            //const fileName = file_link.name;
                                            const reader = new FileReader();

                                            reader.onloadend = () => {
                                              formik.setFieldValue(
                                                `documents[${index}].file_link`,
                                                reader.result
                                              );
                                            };
          
                                            if (file_link) {
                                              reader.readAsDataURL(file_link);
                                            }
                                          }}
                                        />
                                          </div>
                                      </td>

                                    <td>
                                        <div className="form-group status">
                                          <label>File Name</label>
                                          <input
                                            type="text"
                                            className="form-input form-control"
                                            name={`documents[${index}].file_name`}
                                            id={`filename-${index}`}

                                            value={
                                              formik.values.documents[index]
                                                .file_name
                                            }
                                            onChange={(e) => {
                                              formik.handleChange(e);
                                              customHandleInput(e);
                                            }}
                                            onBlur={formik.handleBlur}
                                             />
                                        </div>
                                      </td>
                                     
                                 
                                      <td>
                                        <div className="form-group">
                                          <button
                                            className="btn btn-danger"
                                            style={{ marginTop: 30 }}
                                            type="button"
                                            onClick={() =>
                                              arrayHelpers.remove(index)
                                            }
                                          >
                                            -
                                          </button>
                                        </div>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          )}
                        />
                        
                        


                      <div className="row">
                          <div className="col-md-6">
                            <h4 className="card-title">
                              <br />
                              Add allowance 
                            </h4>
                          </div>
                        </div>
                        <FieldArray
                          name="allowances"
                          render={(arrayHelpers) => (
                            <div>
                              <button
                                className="btn btn-primary mb-3"
                                type="button"
                                // onClick={handleShow}
                                onClick={() =>
                                  arrayHelpers.push({
                                   
                                    allowance: "",
                                    amount:"",
                                  })
                                }
                              >
                                +
                              </button>
                              <table className="table">
                                <tbody>
                                  {formik.values.allowances.map((friend, index) => (
                                    <tr key={index}>
                                      <td style={{width:"30%"}}>
                                          <div className="form-group">
                                            <label> Allowance Type</label><br/>
                                            <Select
                                              name={`allowances[${index}].allowance`}
                                              options={allowancetypes}
                                              value={allowancetypes.find(option => option.value == formik.values.allowances[index].allowance) || null} // Ensure correct format
                                              onChange={(selectedOption) => {
                                                formik.setFieldValue(`allowances[${index}].allowance`, selectedOption.value); // ✅ Store only value in Formik
                                                customHandleInput({
                                                  target: {
                                                    name: `allowances[${index}].allowance`,
                                                    value: selectedOption.value, // ✅ Ensure only value is passed
                                                  },
                                                });
                                                   //  selectotherType(selectedOption);
                                                  selectotherType(selectedOption, index); // ✅ pass index here

                                              }}
                                              onBlur={formik.handleBlur}
                                              placeholder="Select"
                                              className="w-100"
                                          />
                                  
                                          {otherOptions[index] && (
                                                    <div>
                                                      <p>Enter Type</p>
                                                      <input
                                                        type="text"
                                                        name={`allowances[${index}].other_type`}
                                                        value={formik.values.allowances[index].other_type}
                                                        onChange={(e) => {
                                                          formik.handleChange(e);
                                                          customHandleInput(e);
                                                        }}
                                                        onBlur={formik.handleBlur}
                                                        className="form-control"
                                                        placeholder="Other type"
                                                      />
                                                    </div>
                                                  )}
                                                {/* {otheroption && (
                                                  <div>
                                                <p>Enter Type</p>
                                                  <input 
                                                   type="text"
                                                  
                                                   name={`allowances[${index}].other_type`}
                                                   value={
                                                     formik.values.allowances[index]
                                                       .other_type
                                                   }
                                                   onChange={(e) => {
                                                     formik.handleChange(e);
                                                     customHandleInput(e);
                                                   }}
                                                   onBlur={formik.handleBlur}
                                                  className="form-control" placeholder="Other type"  />
                                                  </div>
                                                  
                                                )} */}
                                          </div>
                                      </td>
                                     
                                    
                                      <td  style={{width:"20%"}}>
                                          <div className="form-group">
                                            <label>Amount</label>
                                            <div className="input-group">
                                                  <input 
                                                   type="text"
                                                   onKeyPress={(event) => {
                                                     // Allow only numbers (0-9)
                                                     if (!/^[0-9.]$/.test(event.key) || (event.key == '.' && event.target.value.includes('.'))) {
                                                      event.preventDefault();
                                                    }
                                                   }}
                                                   name={`allowances[${index}].amount`}
                                                   value={
                                                     formik.values.allowances[index]
                                                       .amount
                                                   }
                                                   onChange={(e) => {
                                                     formik.handleChange(e);
                                                     customHandleInput(e);
                                                   }}
                                                   onBlur={formik.handleBlur}
                                                  className="form-control" placeholder="Amount" aria-label="Amount" aria-describedby="basic-addon2" />
                                                  <div className="input-group-append">
                                                      <span className="input-group-text" id="basic-addon2">{currencySymbol}</span>
                                                  </div>
                                              </div>
                                          </div>
                                      </td>
                                      <td>
                                        <div className="form-group">
                                          <button
                                            className="btn btn-danger"
                                            style={{ marginTop: 30 }}
                                            type="button"
                                            onClick={() =>
                                              arrayHelpers.remove(index)
                                            }
                                          >
                                            -
                                          </button>
                                        </div>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          )}
                        />
                     
                      <small>
                        {backendErrors.status  && (
                          <span className="form-error mt-1">
                            {backendErrors.status}
                          </span>
                        )}

                            </small>
                      <div className="text-end mt-4">
                        <button
                          type="submit" id="form-submit"
                          className="btn btn-primary"
                          disabled={formik.isSubmitting}
                        >
                          Add Employee
                        </button>
                      </div>
                     
                    </form>
                      </FormikProvider>
                  </div>
                )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};


export default EmployeeAdd;
